export default __webpack_public_path__ + "static/media/spinner.0e1d0233.jpg";